import { Sparkline } from '@mantine/charts';

import type { ChartRendererProps } from '../types.ts';

/**
 * Renders sparkline chart.
 */
export function SparklineRenderer({ config, width, height }: ChartRendererProps) {
  const sparklineData: (number | null)[] = config.data.map((row) => {
    const val = row[config.yAxis];
    return typeof val === 'number' ? val : null;
  });

  return (
    <Sparkline
      color="blue.6"
      curveType="linear"
      data={sparklineData}
      fillOpacity={0.3}
      h={height}
      strokeWidth={2}
      trendColors={{ positive: 'green.6', negative: 'red.6', neutral: 'gray.5' }}
      w={width}
      withGradient
    />
  );
}
